export class CurrencyMapping {
  [k: string]: string;
}
